import { ENV } from 'public/config'

export const MULTISESSIONKEY = 'ERPMULTIMODULE'

export const setMultiModuleData = function (data) {
  if (data) {
    sessionStorage.setItem(MULTISESSIONKEY, JSON.stringify(data))
  }
}

export const getMultiModuleData = function () {
  const data = sessionStorage.getItem(MULTISESSIONKEY)
  if (data) {
    return JSON.parse(data)
  }
}

/**
 * @description: 是否展示多泳道选择器
 * @param {*} theme:  outer 外层展示 inner 内层展示
 * 1、测试环境直接展示；
 * 2、生产环境根据缓存判断是否展示
 * @returns Boolean
 */
export const getShowMultiModule = function () {
  const isProd = ENV === 'prd'
  let isShow = false
  if (isProd) {
    const multiModules = getMultiModuleData()
    if (multiModules && multiModules.version) {
      isShow = true
    }
  } else {
    isShow = true
  }
  return isShow
}



// WEBPACK FOOTER //
// ./src/layout/utils/index.js